import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import image1 from "../all/BBB_ultimatesroofing.png"
import image2 from "../all/HomeAdvisor_ultimatesroofing.png"
import image3 from "../all/Yelp_ultimatesroofing.png"
import image4 from "../all/owens_corning_ultimatesroofing.png"

const CompanyStats = () => {
  const brandRed = "#b22335";
  const brandNavy = "#3D3B6D";

  const partners = [
    { name: "BBB", url: image1, link: "https://www.bbb.org/us/oh/columbus/profile/roof-replacement/ultimates-roofing-0302-70163978" },
    { name: "HomeAdvisor", url: image2, link: null },
    { name: "Yelp", url: image3, link: "https://www.yelp.com/biz/ultimates-roofing-columbus" },
    { name: "Owens Corning", url: image4, link: null },
  ];

  return (
    <section  style={{ backgroundColor: '#fff' }}>
      <Container>
        {/* Logo Section */}
        <div className="py-lg-2  px-2 rounded-4 " style={{ backgroundColor: '#fff' }}>
          <Row className="align-items-center justify-content-center g-4">
            {partners.map((partner, index) => (
              <Col xs={6} md={3} key={index} className="text-center">
                {partner.link ? (
                  <a
                    href={partner.link}
  target="_blank"
  rel="noopener noreferrer"
  style={{ textDecoration: 'none', display: 'inline-block' }}
  aria-label={`Visit ${partner.name}`}
                  >
                    <img
                      src={partner.url}
                      alt={partner.name}
                      className="img-fluid partner-logo"
                      style={{
                        maxHeight: '80px',
                        transition: 'all 0.4s ease',
                        cursor: 'pointer'
                      }}
                    />
                  </a>
                ) : (
                  <img
                    src={partner.url}
                    alt={partner.name}
                    className="img-fluid partner-logo"
                    style={{
                      maxHeight: '80px',
                      transition: 'all 0.4s ease',
                      cursor: 'default'
                    }}
                  />
                )}
              </Col>
            ))}
          </Row>

          {/* Elegant Continuous Animated Underline */}
          <div 
            className="mt-4 d-flex position-relative" 
            style={{ height: '4px', width: '100%', borderRadius: '10px', overflow: 'hidden', backgroundColor: '#e9ecef' }}
          >
            <motion.div
              animate={{ x: ['-100%', '100%'] }}
              transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
              style={{ 
                width: '50%', 
                background: `linear-gradient(90deg, ${brandRed}, ${brandNavy})`,
                borderRadius: '10px',
                height: '100%'
              }}
            />
          </div>
        </div>
      </Container>

      {/* Hover Effect CSS */}
      <style dangerouslySetInnerHTML={{ __html: `
        .partner-logo {
          filter: none !important;
          opacity: 1 !important;
        }
        .partner-logo:hover {
          transform: scale(1.05);
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }
      `}} />
    </section>
  );
};

export default CompanyStats;